import { render, staticRenderFns } from "./scroll-top-toolbar.vue?vue&type=template&id=62d09e64&scoped=true&"
import script from "./scroll-top-toolbar.vue?vue&type=script&lang=ts&"
export * from "./scroll-top-toolbar.vue?vue&type=script&lang=ts&"
import style0 from "./scroll-top-toolbar.vue?vue&type=style&index=0&id=62d09e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d09e64",
  null
  
)

export default component.exports